import { AVIALABLE_LANG } from "@assets/languages/available-lang";
import { getToastStore } from "@utils/ToastStore";
import { COOKIE_ENUM } from "@webkit/enums/cookie.enum";
import AppEnviroment from "app-enviroment";
import axios from "axios";
import Cookies from "js-cookie";
import { goTo } from "@utils/globalRouter";

const gateway = axios.create({
  baseURL: AppEnviroment.getGatewayUrl(),
});

gateway.interceptors.request.use((config) => {
  // Prende la lingua dall'app nativa se presente, altrimenti dal browser se valida
  const currLang = localStorage.getItem('lang') || navigator.language?.substring(0, 2) || 'en';
  const validLang = AVIALABLE_LANG.includes(currLang) ? currLang : 'en';
  const params = new URLSearchParams(config.params || {});
  params.set('lang', validLang);
  config.params = params;

  //Recupera il token da AsyncStorage e se esiste lo metto nella chiamata
  const token = Cookies.get(COOKIE_ENUM.HST_USER_TOKEN)
  if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
});


gateway.interceptors.response.use(
   
  (response)=>{
    return response;
  },

  (error) => {
    const ctx = getToastStore();   

    if(error.status === 403){
      Cookies.set(COOKIE_ENUM.HST_USER_TOKEN, '')
      Cookies.set(COOKIE_ENUM.HST_USER_PROFILE_DATA, '')
      goTo("/login");
    }
    
    if (error.response) {
        if (ctx) {
          const msg = error.response?.data?.error || "Errore generico";
          ctx.setToastMsg(msg);
          ctx.setSeeToast(true); 
          ctx.setErrorToast(true);
        }
        throw new Error(error.response.data.error);
    } else {
        if (ctx) {
          ctx.setToastMsg(error.message || "Errore di rete");
          ctx.setSeeToast(true);
          ctx.setErrorToast(true);
        }
    }
  }
)
export default gateway;
